module.exports = function() {
  return new Worker(__webpack_public_path__ + "2a7f1bf560c1b9b759ea.worker.js");
};